<template>
  <div
  :open="props.open"
    :class="isOpen ? 'translate-x-0' : 'translate-x-full'"
    class="fixed z-50 top-0 right-0 lg:w-[420px] h-full bg-white transition-all ease-in-out duration-300 transform flex flex-col"
  >

    <div class="flex-grow px-4 py-6 border-b-2 border-b-zinc-100 mx-4">
      <div class="flex">
        <!-- You can list the cart items here -->
        <p class="text-gray-700 font-bold text-xl">Your Cart</p>
        <p class="text-gray-700 font-semibold text-base px-2 py-[3px]">
          (1 Item)
        </p>
      </div>
      <button
        @click="closeCart"
        class="p-2 absolute top-4 right-6 text-black text-xl"
      >
        <XMarkIcon class="w-8 h-8" />
      </button>
      <!-- Rest of the cart content -->

      <!-- divider -->
      <div class="bg-gray-100 h-0.5 w-full mt-4"></div>

      <!-- product in cart -->
      <div class="flex items-center mt-5 gap-5">
        <div>
          <img
            class="w-[150px] h-[150px]"
            src="@/assets/media/images/skin-care-1-default.png"
            alt=""
          />
        </div>

        <!-- product info -->
        <div class="">
          <h2 class="text-gray-700 font-semibold text-lg">Product Title</h2>
          <p class="text-gray-500 font-semibold text-sm">Black / Small</p>
          <p class="text-gray-500 font-semibold text-sm">$17.00</p>
        </div>
      </div>

      <!-- quantity widget -->
      <div class="justify-between flex mt-5">
        <div class="flex items-center">
          <button
            class="border px-3 py-1 rounded-[4px] text-gray-600 font-semibold hover:shadow-md hover:ease-in-out"
          >
            <MinusIcon class="w-5 h-5 hover:opacity-80 hover:ease-in-out" />
          </button>
          <input
            type="text"
            value="1"
            class="border-t border-b w-12 text-center mx-2 rounded-[4px] ease-in-out"
          />
          <button
            class="border px-3 py-1 text-gray-600 font-semibold rounded-[4px] hover:shadow-md ease-in-out"
          >
            <PlusIcon class="w-5 h-5 hover:opacity-80" />
          </button>
        </div>
        <div>
          <button
            class="text-gray-500 font-semibold text-sm hover:opacity-60 hover:ease-in-out hover:text-[#2d8bffce]"
          >
            Remove
          </button>
        </div>
      </div>

      <!-- divider - only show if more than one product ion cart -->
      <div class="bg-gray-100 h-0.5 w-full mt-5"></div>
    </div>

    <!-- subtotal and checkout button -->
    <div class="border-t-2 bg-white">
      <div class="px-4 py-6">
        <div class="flex justify-between">
          <p class="text-gray-700 font-semibold text-lg">Subtotal</p>
          <p class="text-gray-700 font-semibold text-lg">$17.00</p>
        </div>
        <button
          class="bg-[#2d8bffce] rounded-md w-full mt-6 px-3 py-4 text-lg font-semibold text-white shadow-sm hover:bg-[#2d8bff81] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2d8bffce]"
        >
          Secure Checkout
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { XMarkIcon, PlusIcon, MinusIcon } from '@heroicons/vue/24/outline';

// Define props to accept "isOpen"
const props = defineProps({
  isOpen: Boolean
});

const emit = defineEmits(['close']);

// Function to close cart
const closeCart = () => emit('close');
</script>
